import PageCard from '@/components/general/PageCard';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Pill } from '@/components/general/Pill';
import Api from '@/api';
import CommentInside from './CommentInside';
import CreateComment from './CreateComment';
import { Comment } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import { TRIGGERS } from '@/api/global';
import Button from '@/components/common/Button';
import { useTranslations } from 'next-intl';

interface CommentType {
  target?: 'blog' | 'product' | 'service' | 'center';
  targetId?: string | number;
  apiUpdate?: typeof Api.commentUpdate;
  apiDelete?: typeof Api.commentDelete;
  apiInsert?: typeof Api.commentInsert;
  apiList?: typeof Api.commentList;
  showAllRates?: boolean;
  showRateTitle?: boolean;
  titleClass?: string;
  className?: string;
  commentContentStyle?: string;
}

interface newComment {
  content?: string;
  rating?: number | string;
  qualityRating?: number;
  deliveryRating?: number;
  originalityRating?: number;
  id?: string | number | null;
  check?: {
    error: boolean;
    message: string;
  };
}
export default function Comments({
  target,
  targetId,
  apiUpdate = Api.commentUpdate,
  apiDelete = Api.commentDelete,
  apiInsert = Api.commentInsert,
  apiList = Api.commentList,
  showAllRates = false,
  showRateTitle = false,
  titleClass = '',
  className = '',
  commentContentStyle = '',
}: CommentType) {
  const { userInfo, setTrigger, setServerMessage, trigger, setConfirmation, showError } =
    useLayoutContext();
  let [totalCount, setTotalCount] = useState(20);
  const t = useTranslations('common');
  const emptyComment = {
    content: '',
    rating: 0,
    qualityRating: 0,
    deliveryRating: 0,
    originalityRating: 0,
    user: userInfo,
    id: null,
    check: {
      error: false,
      message: t('requiredField'),
    },
  };
  const [comment, setComment] = useState<Comment | newComment>(emptyComment);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<Comment[]>([]);
  const onChange = (value: number | string, key: string) => {
    let result = { ...comment, [key]: value };
    if (key == 'content') {
      result = {
        ...result,
        check: { ...result?.check, error: false, message: t('requiredField') },
      };
    }
    setComment(result);
  };
  const editFunction = (x: Comment) => {
    setComment(x);
    document
      .getElementById('commentInsert')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  const cancelFunction = () => {
    setComment(emptyComment);
  };
  const deleteFunction = (item: Comment) => {
    setConfirmation({
      title: 'حذف دیدگاه',
      text: 'آیا مطمئن هستید؟',
      confirmText: 'بله',
      rejectText: 'خیر',
      confirmFunction: () => callBackDeleteConfirm(item),
      rejectFunction: () => {
        setConfirmation(null);
      },
    });
  };
  const callBackDeleteConfirm = (item: Comment) => {
    apiDelete(item?.id)
      .then((res) => {
        // setTrigger(TRIGGERS.RERENDER);
        setList(list?.filter((x) => x.id != item?.id));
        setServerMessage &&
          setServerMessage({
            type: 'success',
            text: 'پیام شما با موفقیت حذف شد.',
          });
      })
      .catch((err) => {
        showError(err);
      });
  };
  const sendFunction = () => {
    let check = checkError();
    if (check == false) {
      const params = {
        content: comment?.content,
        rating: comment?.rating != 0 ? comment?.rating : undefined,
        qualityRating: comment?.qualityRating != 0 ? comment?.qualityRating : undefined,
        deliveryRating: comment?.deliveryRating != 0 ? comment?.deliveryRating : undefined,
        originalityRating: comment?.originalityRating != 0 ? comment?.originalityRating : undefined,
      };

      let apiCall = comment?.id
        ? apiUpdate({
            id: comment?.id,
            ...params,
          })
        : apiInsert({ ...params, targetId, target: target });

      setLoading(true);
      apiCall
        .then((res) => {
          setComment(emptyComment);
          if (comment?.id) {
            let newarray = [...list];
            let index = list?.findIndex((x) => x?.id == comment?.id);
            if (index != -1) {
              newarray[index] == comment;
              setList(newarray);
            }
          } else {
            getCommentList(0);
          }
          setLoading(false);

          setServerMessage &&
            setServerMessage({
              type: 'success',
              text: 'پیام شما با موفقیت ارسال شد.',
            });
        })
        .catch((err) => {
          setLoading(false);

          showError(err);
        });
    }
  };
  const checkError = () => {
    let result = false;
    let newarray = { ...comment };
    if (comment?.content?.trim()?.length == 0 || !comment?.content) {
      result = true;
      if (newarray?.check) {
        newarray.check.error = true;
      }
    }
    setComment(newarray);
    return result;
  };

  useEffect(() => {
    if (trigger == TRIGGERS.RERENDER) {
      getCommentList(0);
    }
  }, [trigger]);
  const getCommentList = (start = 0, limit = 10) => {
    apiList({
      start: start,
      limit: limit,
      orderBy: 'created_at',
      sort: 'desc',
      target: target,
      targetId: targetId,
    })
      .then((res) => {
        let response;
        if (start == 0) {
          response = res?.data?.response;
        } else {
          response = list?.concat(res?.data?.response);
        }
        setTotalCount(res?.data?.response_details?.count);
        setList(response);
      })
      .catch((err) => {
        showError(err);
      });
  };
  useEffect(() => {
    getCommentList(0);
  }, []);

  return (
    <PageCard
      title={
        <div style={{ gap: '12px', display: 'flex', alignItems: 'center' }}>
          <h3 className={`${styles.sectionTitle} ${titleClass}`}> دیدگاه‌ها</h3>

          <Pill bg={avatarBg(6)} color="var(--brand-deep)">
            {totalCount}
          </Pill>
        </div>
      }
      icon={<MainIcons.ChatIcon width="22px" height="22px" fill="var(--brand-deep)" />}
      backgroundIcon={'transparent'}
      className={`${styles.pageCard} ${className}`}
      titleClass={`${styles.title}`}
      noIconWidth={true}
    >
      <CreateComment
        comment={comment}
        onChange={onChange}
        showAllRates={showAllRates}
        showRateTitle={showRateTitle}
        sendFunction={sendFunction}
        cancelFunction={cancelFunction}
      />
      <CommentInside
        list={list}
        showAllRates={showAllRates}
        showRateTitle={showRateTitle}
        editFunction={editFunction}
        deleteFunction={deleteFunction}
        commentContentStyle={commentContentStyle}
      />
      {list?.length < totalCount && (
        <Button
          className={`btn btn-white squareButton `}
          onClick={() => {
            getCommentList(list?.length);
          }}
          wrapperStyle={`w-auto m-auto ${styles.morebuttonWrapper}`}
        >
          بیشتر
        </Button>
      )}
    </PageCard>
  );
}
